import Exam from './Exam'
export default Exam
